export default __webpack_public_path__ + "static/media/correct.0e6d0649.wav";